<template>
  <div class="side-notification">
    <div :class="iconModifiers"></div>
    <div :class="contentModifiers" v-html="text"></div>
    <div class="side-notification__close-wrapper" @click="onClose">
      <div
        v-if="showAutoCloseLoader"
        class="side-notification__loader"
        :style="{ '--close-timeout': `${closeTimeout}ms` }"
      >
        <svg width="32" height="32" viewBox="0 0 32 32">
          <circle cx="16" cy="16" r="13" class="side-notification__loader-ring" />
        </svg>
      </div>
      <div class="side-notification__close"></div>
    </div>
  </div>
</template>
<script src="./side-notification.js"></script>
<style src="./side-notification.scss" lang="scss"></style>
